"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProjectionFCF = exports.calculateFairPriceFCF = void 0;
var fair_price_shared_1 = require("./fair-price-shared");
function calculateFairPriceFCF(fcfPerShare, sbcPerShare, growthRate, targetFCFYield, requiredReturn, years) {
    if (years === void 0) { years = fair_price_shared_1.DCF_YEARS; }
    var adjustedFCF = sbcPerShare !== null ? fcfPerShare - sbcPerShare : fcfPerShare;
    var terminalValue = (adjustedFCF * Math.pow((1 + growthRate / 100), years)) / (targetFCFYield / 100);
    return terminalValue / Math.pow((1 + requiredReturn / 100), years);
}
exports.calculateFairPriceFCF = calculateFairPriceFCF;
function calculateProjectionFCF(fcfPerShare, sbcPerShare, growthRate, targetFCFYield, requiredReturn, years, totalYears) {
    if (totalYears === void 0) { totalYears = fair_price_shared_1.DCF_YEARS; }
    var adjustedFCF = sbcPerShare !== null ? fcfPerShare - sbcPerShare : fcfPerShare;
    var terminalValue = (adjustedFCF * Math.pow((1 + growthRate / 100), totalYears)) / (targetFCFYield / 100);
    return terminalValue / Math.pow((1 + requiredReturn / 100), (totalYears - years));
}
exports.calculateProjectionFCF = calculateProjectionFCF;
//# sourceMappingURL=fair-price-fcf.js.map